import React from 'react';
import PropTypes from 'prop-types';
import Currency from '../../_utils/tools/currency';
import Select from '../../_utils/select-wrapper';
import { PrintSize, DeliveryOption } from '../prop-types';
import Utils from '../common/size-helpers';
import { QuantityHelpers } from '../common/quantity-helpers';

class PhotosFilter extends React.Component {
  get sizes() {
    const { sizes } = this.props;
    return [
      {
        label: 'All sizes',
        value: Utils.ALL_PHOTOS_KEY,
        disabled: false,
      },
      ...sizes.map((size) => ({
        label: this.generateSizeLabel(size),
        value: size.key,
        disabled: false,
      })),
    ];
  }

  get resizes() {
    const { viewingSizeKey, availableSizes } = this.props;
    return [
      {
        label: 'Resize by filtered',
        value: Utils.ALL_PHOTOS_KEY,
        disabled: false,
      },
      ...availableSizes
        .filter(({ key }) => key !== viewingSizeKey)
        .map((size) => ({
          label: this.generateSizeLabel(size),
          value: size.key,
          disabled: false,
        })),
    ];
  }

  handleChange = (value, func) => {
    let selectedValue = value;

    if (selectedValue === 'undefined') {
      selectedValue = undefined;
    }
    func(selectedValue);
  };

  generateSizeLabel(size) {
    const { deliveryOption } = this.props;
    const price = QuantityHelpers.priceAtQuantityForSize(
      size,
      deliveryOption,
      true,
    );
    return `${size.title} (${Currency.format(price)} ea)`;
  }

  render() {
    const { viewingSizeKey, onChange, onResize, children } = this.props;

    return (
      <div className="d-flex justify-content-between h-100">
        <div className="filter-option filter mr-1">
          <Select
            label="Filter"
            options={this.sizes}
            value={viewingSizeKey || Utils.ALL_PHOTOS_KEY}
            inputStyleLink
            withCaret
            onChange={(value) => this.handleChange(value, onChange)}
          />
        </div>

        {children}

        <div className="filter-option resize">
          <Select
            label="Resize"
            options={this.resizes}
            value=""
            inputStyleLink
            onChange={(value) => this.handleChange(value, onResize)}
          />
        </div>
      </div>
    );
  }
}

PhotosFilter.propTypes = {
  sizes: PropTypes.arrayOf(PrintSize).isRequired,
  availableSizes: PropTypes.arrayOf(PrintSize).isRequired,
  deliveryOption: DeliveryOption.isRequired,
  viewingSizeKey: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onResize: PropTypes.func.isRequired,
  children: PropTypes.element,
};

PhotosFilter.defaultProps = {
  viewingSizeKey: undefined,
  children: null,
};

export default PhotosFilter;
